import React, { useState } from "react"
import styled from "styled-components"
import Title from "@/containers/MoneyFortune/View/homeWEB3/Title"
import AnswerCard from "@/containers/MoneyFortune/View/decorate/AnswerCard"
import BackBtn from "./BackBtn"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"

export default function QuestionCard({
  number,
  question,
  answers,
  type,
  changeQuestion,
  preQuestion,
  customFor,
  marks,
  setMarks,
  questionNum,
  setQuestionNum
}) {
  const [animation, SetAnimation] = useState(false)
  const [clicked, setClicked] = useState(false)

  const PreQuestion = () => {
    setQuestionNum(prevCount => prevCount - 1)
    marks.pop()
  }
  return (
    <Wrapper className={animation === true && "active"}>
      <TitleWrapper className="TitleWrapper">
        <Title title1={`Q${number}`} title2={question} type="question" />
      </TitleWrapper>
      <AnswersBlock
        className={`${
          type === "Image" ? "AnswersBlock image" : "AnswersBlock"
        } ${answers.length >= 4 && "col2"}`}
      >
        {answers?.map(({ content, count1, count2, img }) => {
          const changeQuestionHolder = () => {
            if (clicked === false) {
              setClicked(true)
              setMarks([
                ...marks,
                {
                  id: number,
                  mark1: count1,
                  mark2: count2,
                  content: content
                }
              ])
              SetAnimation(true)
              changeQuestion()
            }
            return
          }

          return (
            <AnswerWrapper
              className={`${type === "Image" && "image"}`}
              key={content}
              onClick={changeQuestionHolder}
            >
              <AnswerCard
                content={type === "Image" ? img : content}
                type={type}
                customFor={customFor}
              />
            </AnswerWrapper>
          )
        })}
      </AnswersBlock>
      {questionNum > 1 && (
        <BTNWrapper>
          <BackBtn
            content={
              <div>
                <KeyboardArrowLeftIcon />
                Back
              </div>
            }
            onClick={PreQuestion}
            customFor={customFor}
          />
        </BTNWrapper>
      )}
      <Floor>
        <p>Powered by KryptoGO</p>
      </Floor>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 20px;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 768px) {
    height: calc(var(--vh) * 0.7);
    margin-top: -60px;
    padding: 20px;
    gap: 30px;
  }
  &.active {
    .TitleWrapper {
      animation: QATitleback 1s forwards;
      @keyframes QATitleback {
        0% {
          opacity: 1;
          transform: translate(0, 0);
        }
        100% {
          opacity: 0;
          transform: translate(0, -10vh);
        }
      }
    }
    .AnswersBlock {
      animation: Blockback 1s forwards;
      will-change: transform;
      @keyframes Blockback {
        0% {
          opacity: 1;
          transform: translate(0, 0);
        }
        100% {
          opacity: 0;
        }
      }
    }
  }
`
const TitleWrapper = styled.div`
  animation: QATitle 1s forwards;
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  transition: 0.3s;
  will-change: transform;
  @keyframes QATitle {
    0% {
      opacity: 0;
      transform: translate(0, -10vh);
    }
  }
`

const AnswersBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  gap: 16px;
  animation: QABlock 1.5s forwards;
  transition: 0.3s;
  will-change: transform;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    height: auto;
  }
  @keyframes QABlock {
    0% {
      opacity: 0;
    }
  }
  &.image {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    max-width: 1000px;
    @media (max-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 16px;
      > div {
        max-width: 150px;
      }
    }
  }
  &.col2 {
    max-width: 1000px;
    grid-template-columns: 1fr 1fr;
    height: auto;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      justify-content: center;
      > div {
        width: 100%;
      }
    }
  }
`

const AnswerWrapper = styled.div`
  width: 100%;
`

const BackBtnWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`

const BTNWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  will-change: transform;
  z-index: 3;
  @media (max-width: 600px) {
    bottom: 50px;
  }
`
const Floor = styled.div`
  width: 100%;
  height: 50px;
  background: #4646f5;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: end;
  align-items: center;
  left: 0px;
  p {
    text-align: right;
    padding: 20px;
    margin: 0 auto;
    width: clamp(0px, 100%, 1400px);
    @media (max-width: 768px) {
      text-align: center;
    }
  }
`
